export * from "@auth/core/providers/credentials";
export { default } from "@auth/core/providers/credentials";
